<template>
<div>
    <Breadcrumbs main="HR" submain="Payroll" title="Payroll Sheet Detail" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div> 
            </b-button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <!-- <div class="card-header">
                        <button class="btn btn-primary" v-b-modal.modal-disbursement-create  style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Generate Disbursement</h7>
                        </button>
                    </div> -->
        

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectedDepartment ||  selectedDesignation  || filter || selectedDisbursed">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row my-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                    <div class="grid-item">
                                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                                    </div>
                                    <div class="grid-item" v-if="selectedDepartment">
                                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                                    </div>
                                    <div class="grid-item">
                                        
                                            <b-form-select id="closure-name" v-model="selectedDisbursed" :options="disbursed_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Disbursement
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        
                                    </div>
                                    <!-- <div class="grid-item" v-if="selectedDesignation">
                                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <div class="table-width ">
                            <div class="d-flex align-items-end justify-content-end mt-2 w-100">
                                 <b-button
                                    size="sm"
                                    variant="outline-primary"
                                    @click="showAll = !showAll"
                                    
                                >
                                    {{ showAll ? 'Hide Disbursed' : `Show All (${items.length})` }}
                            </b-button>
                            </div>
                           
                            <div v-if="!loading && !error"  class="mt-3">
                                <div class="table-responsive datatable-vue">
                                    <b-table show-empty stacked="md" :items="filteredItems" :fields="tablefields">

                                 <template #cell(select)="data">
                                    <div v-if="!data.item.is_disbursed && data.item.has_bank_account" class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :id="'employee-' + data.item.id"
                                            :checked="isSelected(data.item.id)"
                                            @change="toggleEntry(data.item, $event.target.checked)"
                                        >

                                        <label
                                            class="form-check-label"
                                            :for="'employee-' + data.item.id"
                                        ></label>
                                    </div>
                                </template>
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                 <template #cell(employee_name)="data">
    <div>
        <strong>{{ data.item.employee.full_name }}</strong>

        <span
            v-if="!data.item.has_bank_account"
            class="ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Employee has not added bank information"
        >
            <i class="fa fa-exclamation ml-2" style="color: #DC3545;"></i>
        </span>

        <br>

        <small>
            {{ data.item.employee.additional_info.employee_id }}
        </small>

        <br>

        <span
            class="badge"
            :class="{
                'bg-danger': data.item.payroll_slip?.payment_status === 'UNPAID',
                'bg-warning': data.item.payroll_slip?.payment_status === 'PARTIALLY_PAID',
                'bg-success': data.item.payroll_slip?.payment_status === 'PAID'
            }"
        >
            {{ data.item.payroll_slip?.payment_status?.replaceAll('_', ' ') }}
        </span>
    </div>
</template>

                                        <template #cell(gross_salary)="data">
                                            ৳ {{ Number(data.item.gross_salary).toLocaleString() }}
                                        </template>

                                        <template #cell(net_pay)="data">
                                          <div class="d-flex flex-column" style="gap:6px">
                                              <h7> <span style="font-weight: 600;"> Paid: </span> ৳ {{ Number(data.item?.payroll_slip?.paid_amount).toLocaleString() }}</h7>
                                              <h7>  <span style="font-weight: 600;"> Due:</span>  ৳ {{ Number(data.item?.payroll_slip?.due_amount).toLocaleString() }}</h7>
                                          </div>
                                        </template>

                                        <template #cell(status)="data">
                                            <span class="badge" :class="data.item.is_disbursed ? 'badge-success' : 'badge-warning'">
                                                {{ data.item.is_disbursed ? 'Disbursed' : 'Pending' }}
                                            </span>
                                        </template>

                                        <template #cell(actions)="data">
                                            <b-button size="sm" variant="primary" @click="viewPayroll(data.item)">
                                                View Details
                                            </b-button>
                                            
                                        </template>
                                        <template #cell(pay_amount)="data">
                                            <input
                                                v-if="isSelected(data.item.id)"
                                                type="number"
                                                class="form-control"
                                                v-model.number="getEntry(data.item.id).pay_amount"
                                                @input="validatePayAmount(data.item)"
                                            >

                                            <span v-else>
                                                {{ Number(data.item?.payroll_slip?.due_amount).toLocaleString() }}
                                            </span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                            <div v-else>
                                <div class="loader-box">
                                    <div class="loader-10"></div>
                                </div>
                            </div>
                            <b-col class="my-1 p-0" >
                                 <div class="d-flex flex-row flex-wrap" style="gap: 6px;" v-if="entries?.length">
                                     <p style="font-weight: 500; font-size: 14px;">{{ entries.length }} of {{ count }} Employees Selected.</p>
                                     <p v-b-modal.modal-disbursement-create style="text-decoration: underline; color: #DC3545;">Generate Disbursement</p>
                                 </div>
                                
                            </b-col>

                            <b-col class="my-1 p-0">
                                <b-row class="mt-3">
                                    <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                        <span>
                                            <!-- First Page Button (<<) -->
                                            <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                <b-icon icon="chevron-double-left"></b-icon>
                                            </button>

                                            <!-- Previous Page Button (<) -->

                                            <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                <b-icon icon="chevron-left"></b-icon>
                                            </button>
                                        </span>

                                        <span class="align-self-center">
                                            <span class="align-self-center">
                                                <span class="d-flex align-items-center" style="gap: 6px;">
                                                    <span>Page</span>
                                                    <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                    <span>of {{ totalPages }}</span>
                                                </span>
                                            </span>
                                        </span>

                                        <span>
                                            <!-- Next Page Button (>) -->
                                            <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                <b-icon icon="chevron-right"></b-icon>
                                            </button>

                                            <!-- Last Page Button (>>) -->
                                            <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                <b-icon icon="chevron-double-right"></b-icon>
                                            </button>
                                        </span>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </div>
                        <div class="table-width mt-5">
                            <h5 class="mb-4">Disbursements</h5>
                             <div class="table-responsive datatable-vue">
                                        <b-table show-empty stacked="md" :items="disbursements" :fields="disbursementfields" >

                                            <template #cell(index)="data">
                                                {{ data.index + 1 }}
                                            </template>

                                            <template #cell(title)="data">
                                                <router-link :to="`/hr/payroll/disbursement-sheet/detail/${data.item.id}`">
                                                       <strong>{{ data.item.title }}</strong>
                                                <br>
                                                <small class="text-muted">
                                                    {{ data.item.notes }}
                                                </small>
                                                </router-link>
                                            </template>

                                            <template #cell(payroll_sheet)="data">
                                                <span v-if="data.item.payroll_sheet">
                                                    {{ data.item.payroll_sheet.month }}/{{ data.item.payroll_sheet.year }}
                                                    <br>
                                                    <small class="text-muted">
                                                        {{ data.item.payroll_sheet.status }}
                                                    </small>
                                                </span>

                                                <span v-else class="text-muted">
                                                    N/A
                                                </span>
                                            </template>

                                            <template #cell(created_by)="data">
                                                <div class="d-flex align-items-center">

                                                    <div>
                                                        {{ data.item.created_by?.full_name || 'N/A' }}
                                                        <br>
                                                        <small class="text-muted">
                                                            {{ data.item.created_by?.email || 'N/A' }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </template>

                                            <template #cell(total_entries)="data">
                                                {{ data.item.total_entries }}
                                            </template>

                                            <template #cell(total_pay_amount)="data">
                                                ৳ {{ Number(data.item.total_pay_amount || 0).toLocaleString() }}
                                            </template>

                                            <template #cell(status)="data">
                                                <b-badge @click="toggleDisbursement(data.item.id, data.item.status)" :variant="{
                                                    DRAFT: 'secondary',
                                                    APPROVED: 'success',
                                                    DISBURSED: 'primary'
                                                }[data.item.status] || 'warning'" style="cursor: pointer;">
                                                    {{ data.item.status }}
                                                </b-badge>
                                            </template>

                                            <template #cell(created_on)="data">
                                                {{ formatDate(data.item.created_on) }}
                                            </template>
                                            

                                        </b-table>
                                    </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Payroll Details Modal -->

    <b-modal id="payroll-details-modal" size="lg" title="Payroll Details" hide-footer modal-class="payroll-modal">
        <div v-if="selectedPayroll">

            <div class="row payroll-content">

                <!-- Employee Information -->
                <div class="col-md-6 mb-4">
                    <div class=" payroll-card">
                        <div class="payroll-card-header">
                            Employee Information
                        </div>

                        <div class="card-body payroll-card-body">
                            <div class="payroll-info-item">
                                <span class="payroll-label">Name</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.employee?.full_name }}
                                </span>
                            </div>

                            <div class="payroll-info-item">
                                <span class="payroll-label">Employee ID</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.employee?.additional_info?.employee_id }}
                                </span>
                            </div>

                            <div class="payroll-info-item">
                                <span class="payroll-label">Email</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.employee?.email }}
                                </span>
                            </div>

                            <div class="payroll-info-item">
                                <span class="payroll-label">Phone</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.employee?.additional_info?.phone_number }}
                                </span>
                            </div>

                            <div class="payroll-info-item">
                                <span class="payroll-label">Department</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.department }}
                                </span>
                            </div>

                            <div class="payroll-info-item">
                                <span class="payroll-label">Designation</span>
                                <span class="payroll-value">
                                    {{ selectedPayroll?.designation }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Bank Information -->
                <div class="col-md-6 mb-4">
                    <div class=" payroll-card">
                        <div class=" payroll-card-header">
                            Bank Information
                        </div>

                        <div class="card-body payroll-card-body">
                            <p> <strong>Bank:</strong> {{ selectedPayroll?.bank_detail?.bank_name }} </p>
                            <p> <strong>Account Number:</strong> {{ selectedPayroll?.bank_detail?.account_number }} </p>
                            <p> <strong>Routing Number:</strong> {{ selectedPayroll?.bank_detail?.routing_number }} </p>
                            <p> <strong>District:</strong> {{ selectedPayroll?.bank_detail?.district }} </p>
                            <p> <strong>Branch:</strong> {{ selectedPayroll?.bank_detail?.branch }} </p>
                        </div>
                    </div>
                </div>

                <!-- Inclusions -->
                <div class="col-md-6">
                    <div class=" payroll-card">
                        <div class=" payroll-card-header">
                            Inclusions
                        </div>

                        <div class="card-body payroll-card-body">
                            <table class="table payroll-table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th class="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in selectedPayroll.inclusion" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td class="text-right"> ৳ {{ item.amount }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Deductions -->
                <div class="col-md-6">
                    <div class=" payroll-card">
                        <div class="payroll-card-header">
                            Deductions
                        </div>

                        <div class="card-body payroll-card-body">
                            <table class="table payroll-table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th class="text-right">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in selectedPayroll.deduction" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td class="text-right"> ৳ {{ item.amount }} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- Summary -->
                <div class="col-12 mt-4">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-gross">
                                <small>Gross Salary</small>
                                <h3>৳ {{ selectedPayroll?.gross_salary }}</h3>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-net">
                                <small>Net Pay</small>
                                <h3>৳ {{ selectedPayroll?.net_pay }}</h3>
                            </div>
                        </div>

                        <div class="col-md-4 mb-3">
                            <div class="payroll-summary payroll-status">
                                <small>Status</small>
                                <h3>
                                    {{
                            selectedPayroll.is_disbursed
                                ? 'Disbursed'
                                : 'Pending'
                        }}
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </b-modal>

    <!-- Disbursement Modal -->


    <b-modal id="modal-disbursement-create" title="Create Disbursement" centered  @ok="handleDisbursement">
        <form ref="form" @submit.stop.prevent="handleDisbursementSubmit">
            <div class="mt-2 mb-3">
                <b-form-group label="Title" label-for="title" invalid-feedback="Title is required" :state="nameState">
                    <b-form-input id="notes" v-model="disbursement.title" type="text" placeholder="Enter title" :state="nameState" required></b-form-input>
                </b-form-group>
                <b-form-group label="Notes" label-for="notes" invalid-feedback="Note is required" :state="nameState">
                    <b-form-input id="notes" v-model="disbursement.notes" type="text" placeholder="Enter notes" :state="nameState" required></b-form-input>
                </b-form-group>
                <!-- <b-form-group label="Employee" invalid-feedback="Employee is required" :state="nameState">
                    <multiselect v-model="entries" tag-placeholder="Add Entry" placeholder="Search employee" label="name" :max="employee_list.length" track-by="id" :options="employee_list" :multiple="true" :taggable="true" :state="nameState" required></multiselect>
                </b-form-group> -->
                                
            </div>
        </form>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
export default {
    components: {
        Multiselect,
        Datepicker
    },

    data() {
        return {
            tablefields: [
                {
                    key: 'select',
                    label: 'Select'
                },
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'employee_name',
                    label: 'Employee'
                },
                {
                    key: 'department',
                    label: 'Department'
                },
                {
                    key: 'designation',
                    label: 'Designation'
                },
                {
                    key: 'gross_salary',
                    label: 'Gross Salary'
                },
                {
                    key: 'net_pay',
                    label: 'Net Pay'
                },
                {
                    key: 'pay_amount',
                    label: 'Payable Amount'
                },
                {
                    key: 'status',
                    label: 'Disbursement Status'
                },
                {
                    key: 'actions',
                    label: 'Actions'
                }
            ],
            selectedPayroll: null,
            filter: null,
            filterShow: false,
            initialLoad: true,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            loadingPage: false,
            pageInput: 1,
            pageInputDebounce: null,

            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            selectedDisbursed: null,

            disbursed_list:[
                {
                    value: true,
                    text:'Yes',
                },
                {
                    value:false,
                    text:'No',
                },
                

            ],
            nameState: null,
            disbursement:{
                payroll_sheet: this.$route.params.id,
                title: '',
                notes:'',
            },
            entries:[],

            disbursementfields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'payroll_sheet',
                    label: 'Payroll Sheet',
                    sortable: true
                },
                {
                    key: 'created_by',
                    label: 'Created By',
                    sortable: true
                },
                {
                    key: 'total_entries',
                    label: 'Entries',
                    sortable: true
                },
                {
                    key: 'total_pay_amount',
                    label: 'Amount',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Created On',
                    sortable: true
                },
                // {
                //     key: 'action',
                //     label: 'Action'
                // }
            ],
            showAll: false
            

            

        };
    },

    computed: {
        ...mapState({
            items: state => state.payroll.payroll_sheet_detail,
            loading: state => state.payroll.payrollLoading,
            error: state => state.payroll.payrollError,
            count: state => state.payroll.payroll_sheet_detail_count,

            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,

            disbursements: state => state.payroll.disbursement_sheet,


            

        }),

        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },
          employee_list() {
        return this.items.map(item => ({
            id: item?.id,
            name: `${item.employee?.full_name || 'N/A'} | ${item.department || 'N/A'} - ${item.designation || 'N/A'}`
        }))
    },
        filteredItems() {
            if (this.showAll) {
                return this.items
            }

            return this.items.filter(item => !item.is_disbursed)
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        },

      
    },

    mounted() {
        this.$store.dispatch("payroll/fetchDisbursementList", {
            payrollSheet: this.$route.params.id,
        });
     
        this.$store.dispatch("department/fetchDepartments");
        const query = this.$route.query;
        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage;
        this.perPage = parseInt(query.perPage) || 25;

        if (query.department) {
            this.selectedDepartment = query.department;
        }
        if (query.designation) {
            this.selectedDesignation = query.designation;
        }
        if (query.is_disbursed ) {
            this.selectedDisbursed = query.is_disbursed;
        }
      

        if (this.selectedDepartment || this.selectedDesignation ||  this.filter || this.selectedDisbursed) {
            this.filterShow = true;
        }

        this.updateRouteQuery();
        this.fetchInitialUpdate();

    },

    watch: {
        filteredItems(newItems) {
            if (!newItems.length && this.currentPage < this.totalPages) {
                this.currentPage++
            }
        },
        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        currentPage(newVal, oldVal) {
            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }
            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },

        selectedDisbursed(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },


        // selectedEmployee(newVal, oldVal) {
        //     if (!this.initialLoad) {
        //         this.currentPage = 1;
        //         this.pageInput = 1;
        //         this.updateRouteQuery();
        //         this.fetchData();
        //     }
        // },


        
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        validatePayAmount(item) {
            const entry = this.getEntry(item.id)

            if (!entry) return

            if (entry.pay_amount > item.payroll_slip?.due_amount) {
                entry.pay_amount = item.payroll_slip?.due_amount
            }

            if (entry.pay_amount < 0) {
                entry.pay_amount = 0
            }
        },
        toggleEntry(item, checked) {
            if (checked) {
                this.entries.push({
                    payroll_sheet_entry: item.id,
                    pay_amount: item.payroll_slip?.due_amount
                })
            } else {
                this.entries = this.entries.filter(
                    e => e.payroll_sheet_entry !== item.id
                )
            }
        },

        isSelected(id) {
            return this.entries.some(
                e => e.payroll_sheet_entry === id
            )
        },

        getEntry(id) {
            return this.entries.find(
                e => e.payroll_sheet_entry === id
            )
        },
        formatDate(date) {
            return date ?
                moment(date).format('DD MMM YYYY') :
                'N/A'
        },
        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            };

           
            if (this.filter) {
                query.search_term = this.filter;
            }
            if (this.selectedDepartment) {
                query.department = this.selectedDepartment;
            }
            if (this.selectedDesignation) {
                query.designation = this.selectedDesignation;
            }
            if (this.selectedDisbursed) {
                query.is_disbursed = this.selectedDisbursed;
            }

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("payroll/fetchPayrollSheetDetail", {
                sheet_id: this.$route.params.id,
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                department: this.selectedDepartment,
                designation: this.selectedDesignation,
                is_disbursed: this.selectedDisbursed,

            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("payroll/fetchPayrollSheetDetail", {
                    sheet_id: this.$route.params.id,
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,
                    department: this.selectedDepartment,
                    designation: this.selectedDesignation,
                    is_disbursed: this.selectedDisbursed,

                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },

        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        viewPayroll(item) {
            this.selectedPayroll = item;
            this.$bvModal.show('payroll-details-modal');
        },
        clearFilter(){
            this.selectedDepartment = '',
            this.selectedDesignation = '',
            this.filter = null,
            this.selectedDisbursed = ''
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },

        handleDisbursement(bvModalEvent){
            bvModalEvent.preventDefault()
            this.handleDisbursementSubmit()
        },
        handleDisbursementSubmit(){
            if (!this.checkFormValidity()) {
                return
            }
            // const employeeIds = this.entries.map(item => item.id)
            this.$store.dispatch("payroll/generateDisbursement", 
                {
                    disbursement: this.disbursement,
                    entries: this.entries,
                    payrollSheet: this.$route.params.id
                }
            ).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.disbursement = {
                payroll_sheet: this.$route.params.id,
                title: '',
                notes:'',
            }
            this.entries = []


            this.$nextTick(() => {
                this.$bvModal.hide('modal-disbursement-create')
            })
        },
        toggleDisbursement(id, status) {
            let action = ''

            if (status === 'DRAFT') {
                action = 'approve'
            } else if (status === 'APPROVED') {
                action = 'disburse'
            }
            else if (status === 'DISBURSED') {
                    Swal.fire({
                        title: "Info!",
                        text: 'Already Disbursed',
                        icon: "info"
                    })
                    return
            }

            this.$store.dispatch("payroll/tooggleDisbursement", {
                id:id,
                status: action,
                payrollSheet: this.$route.params.id,
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                department: this.selectedDepartment,
                designation: this.selectedDesignation,
                is_disbursed: this.selectedDisbursed,
               
            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    })
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    })
                }

            })
        },

    }
};
</script>

<style scoped>
.payroll-modal .modal-content {
    border: 0;
    border-radius: 16px;
    overflow: hidden;
    background: #f8fafc;
}

.payroll-modal .modal-header {
    border-bottom: 1px solid #edf2f7;
    background: #fff;
    padding: 1rem 1.5rem;
}

.payroll-modal .modal-title {
    font-weight: 600;
    font-size: 18px;
}

.payroll-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 100%;
}

.payroll-card-header {
    background: #fff !important;
    font-weight: 600;
    color: #334155;
    padding: 24px 24px 0px 24px;
}

.payroll-card-body {
    background: #fff;
}

.payroll-info-item {
    margin-bottom: 12px;
}

.payroll-label {
    display: block;
    color: #64748b;
    font-size: 12px;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: .5px;
}

.payroll-value {
    display: block;
    color: #1e293b;
    font-size: 15px;
    font-weight: 500;
}

.payroll-table {
    margin-bottom: 0;
}

.payroll-table thead th {
    background: #f8fafc;
    border-top: none;
    font-size: 13px;
    font-weight: 600;
    color: #475569;
}

.payroll-table tbody td {
    vertical-align: middle;
}

.payroll-summary {
    border-radius: 14px;
    padding: 24px;
    text-align: center;
    color: #fff;
}

.payroll-summary small {
    display: block;
    font-size: 13px;
    margin-bottom: 8px;
    opacity: .9;
}

.payroll-summary h3 {
    margin: 0;
    font-weight: 700;
}

.payroll-gross {
    background: linear-gradient(135deg, #4f46e5, #6366f1);
}

.payroll-net {
    background: linear-gradient(135deg, #059669, #10b981);
}

.payroll-status {
    background: linear-gradient(135deg, #d97706, #f59e0b);
}

.payroll-card:hover {
    transform: translateY(-2px);
    transition: all .3s ease;
}
</style>
